var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlacedSite = function SvgPlacedSite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 800,
    viewBox: "0 0 32 32"
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "placed-site_svg__SVGRepo_iconCarrier"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".placed-site_svg__cls-1{fill:#77acf1}"))), /*#__PURE__*/React.createElement("g", {
    id: "placed-site_svg___32._Worldwide",
    "data-name": "32. Worldwide"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 9.67v-.09a15 15 0 0 0-28 0v.09a14.73 14.73 0 0 0 0 10.67v.07A15.06 15.06 0 0 0 13.93 30H14a1 1 0 0 0 1-1v-1a1 1 0 0 0-.34-.58A16.7 16.7 0 0 1 10.15 21H14a1 1 0 0 0 0-2H9.51A16 16 0 0 1 9 15a16.5 16.5 0 0 1 .5-4h11a16.5 16.5 0 0 1 .5 4 1 1 0 0 0 2 0 19 19 0 0 0-.43-4h4.79a12.9 12.9 0 0 1 .64 4 1 1 0 0 0 2 0 14.8 14.8 0 0 0-1-5.33m-17 18A13.08 13.08 0 0 1 3.49 21H8a18.5 18.5 0 0 0 4 6.65ZM2.65 19A12.7 12.7 0 0 1 2 15a12.9 12.9 0 0 1 .64-4h4.79A19 19 0 0 0 7 15a18.3 18.3 0 0 0 .45 4ZM8 9H3.48A13 13 0 0 1 12 2.36 18.3 18.3 0 0 0 8 9m2.15 0A16.76 16.76 0 0 1 15 2.28 16.76 16.76 0 0 1 19.86 9ZM22 9a18.3 18.3 0 0 0-4-6.64A13 13 0 0 1 26.52 9Z",
    className: "placed-site_svg__cls-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22 19h4v3a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1z",
    style: {
      fill: "#77acf1"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 32h-8a3 3 0 0 1-3-3v-8a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3m-8-12a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1Z",
    className: "placed-site_svg__cls-1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23 28h-1a1 1 0 0 1 0-2h1a1 1 0 0 1 0 2",
    className: "placed-site_svg__cls-1"
  })))));
};
export default SvgPlacedSite;